import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import SeoMeta from "./seometa";
import ResponsiveImage from "./responsiveimage";

export default function BlogList({
  baseURL = "https://gantasoft.in/rankridgeschool/dev/v1",
  status=true
}) {
  const api = useMemo(() => axios.create({ baseURL }), [baseURL]);
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try {
      const params = { status: "published", include_tags: 1, sort: "published_at", order: "DESC", page, limit: 9 };
      if (q.trim()) params.q = q.trim();
      const { data } = await api.get("/posts", { params });
      setRows(data?.items || []);
      setPages(data?.pagination?.pages || 0);
      setTotal(data?.pagination?.total || 0);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q, page]);


const seopages = {
    title: "Rankridge Blog – IIT JEE & NEET Foundation Coaching Tips & Updates",
    description:
      "Discover expert tips, strategies, and success stories on IIT JEE & NEET foundation coaching. Stay updated with Rankridge Schools news and exam resources.",
    keywords: " rankridge academics, cbse academics hyderabad, state board academics hyderabad, rankridge curriculum, rankridge academic excellence, best cbse syllabus school hyderabad, best state syllabus school hyderabad, academic programs rankridge, rankridge competitive exam preparation, iit jee foundation academics, neet foundation academics, rankridge academic performance, school academic achievements hyderabad, rankridge learning approach, cbse board results hyderabad, state board results hyderabad, rankridge education methods, best academic school hyderabad, academic syllabus rankridge, school academics with competitive edge",
    canonical_path: "https://rankridgeschools.com/blog/",
    og_description: "",
    og_image: "",
  };


  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
       {/* <SeoMeta seopages={seopages} /> */}
       <center>
        <h1 className="text-2xl  md:text-3xl font-extrabold tracking-tight">Latest Articles</h1>
        </center>
      <div className="flex items-end justify-between gap-3">
        
        {/* <input
          value={q}
          placeholder="Search articles…"
          onChange={(e)=>{ setPage(1); setQ(e.target.value); }}
          className="border px-3 py-2 rounded w-64"
        /> */}
      </div>

      {loading ? (
        <div className="grid md:grid-cols-3 gap-6 mt-6">
          {[...Array(6)].map((_,i)=>(
            <div key={i} className="animate-pulse h-72 bg-gray-100 rounded" />
          ))}
        </div>
      ) : rows.length === 0 ? (
        <p className="text-gray-500 mt-8">No posts yet.</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {rows.map(p => (
            <Link to={`/blog/${p.slug}`} key={p.post_id} className="group rounded-2xl overflow-hidden bg-white shadow hover:shadow-lg transition">
              <div className="relative h-48 bg-gray-100 overflow-hidden">
                {p.cover_image ? (

                  
                  // <img src={"https://gantasoft.in/rankridgeschool/dev"+ p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition" />

                  <ResponsiveImage
  avif={"https://gantasoft.in/rankridgeschool/dev"+ p?.cover_image}
  webp={"https://gantasoft.in/rankridgeschool/dev"+ p?.cover_image}
  srcFallback={"https://gantasoft.in/rankridgeschool/dev"+ p?.cover_image}   // 👈 main fallback
  alt={p.title}
  eager // eager for LCP
  className="w-full h-full object-cover group-hover:scale-105 transition"
/>
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">No image</div>
                )}
                {p.is_featured ? (
                  <span className="absolute top-3 left-3 text-xs bg-amber-500 text-white px-2 py-1 rounded-full">Featured</span>
                ) : null}
              </div>
              <div className="p-4">
                <div className="flex flex-wrap gap-2">
                  {p.category_name && <span className="text-[10px] uppercase tracking-wide bg-gray-100 px-2 py-1 rounded">{p.category_name}</span>}
                  {(p.tags||[]).slice(0,2).map(t=>(
                    <span key={t.tag_id} className="text-[10px] uppercase tracking-wide bg-gray-100 px-2 py-1 rounded">#{t.name}</span>
                  ))}
                </div>
                <h3 className="mt-2 text-lg font-bold line-clamp-2">{p.title}</h3>
                {p.excerpt && <p className="text-sm text-gray-600 mt-1 line-clamp-2">{p.excerpt}</p>}
                <div className="mt-3 text-xs text-gray-500 flex items-center gap-2">
                  <span>{p.published_at ? new Date(p.published_at).toLocaleDateString() : '—'}</span>
                  <span>•</span>
                  <span>{p.reading_time_min || 1} min read</span>
                  {/* <span className="ml-auto">{p.view_count ?? 0} views</span> */}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      {pages > 1 && (
        <div className="flex items-center justify-center gap-2 mt-8">
          <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page<=1} className="px-3 py-1.5 rounded bg-gray-200 disabled:opacity-50">Prev</button>
          <span className="text-sm">Page {page} of {pages} • {total} articles</span>
          <button onClick={()=>setPage(p=>Math.min(pages,p+1))} disabled={page>=pages} className="px-3 py-1.5 rounded bg-gray-200 disabled:opacity-50">Next</button>
        </div>
      )}

      {status && <SeoMeta seopages={seopages} />}
    </div>
  );
}
